export const TOUR_MENU_NAMES={
    MENUS:"Menus Tour",
    GET_STARTED:"Getting Started Tour",
    ASSEMBLY_TREE:"Assembly Tree Tour",
    CLIP_PLANES:"Clip Planes Tour",
    GUIDES:"Guides Tour",
    DISPLAY_MODES:"Display Modes Tour",
    HISTORY:"History Tour",
    LABELS:"Labels Tour",
    AVERAGE_OPTIONS:"Average Options Tour",
    MOUSE_CONTROL:"Mouse Control Tour",
    MOUSE_CONTROL_EDIT:"Mouse Control Edit Tour",
    AVERAGE_OPTIONS_EDIT:"Average Option Edit Tour",
    SLIDES:"3D Slides Tour",
    ANIMATION:"Animation Tour",
    COLOR_THEME:"Color Theme Tour",
    AXIS_TRIAD:"Axis Triad Tour",
    BACKGROUND:"Background Tour",
    CAMERA:"Camera Tour",
    COLOR_MAP_LIST:"Color Map List Tour",
    COLOR_PALETTE:"Color Palette Tour",
    DERIVED_TYPE:"Derived Type Tour",
    EIGEN_VECTOR:"Eigen Vector Tour",
    LEGEND_SETTING:"Legend Setting Tour",
    LINEAR:"Linear Animation Tour",
    PARTS_LIST:"Parts List Tour",
    TRANSIENT:"Transient Animation Tour",
    VALUE_SETTINGS:"Value Settings Tour",
    VARIABLES:"Variables Tour",
    VIEW_POINT:"View Point Tour",
    STEPS_AND_SUBCASE:"Steps & Subcase Tour",
    COLOR_MAP_EDIT:"Color Map Edit Tour",
    TOOLBAR:'ToolBar'

}